module.exports = __webpack_public_path__ + "img/ebcJp.e60a293b.svg";